ns.App.factory('SessionsService', function ($http, API_ENDPOINT) {
  return {
    postSessions: function (checkedAttrs) {
      return $http.post('/top', {"ids": checkedAttrs});
    }
  };
});

